var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.198,
    height: 19.018,
    viewBox: "0 0 34.198 24.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8304",
    "data-name": "Group 8304",
    transform: "translate(15997.311 19313.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16071",
    "data-name": "Path 16071",
    d: "M890.893,14.514c4.1.227,8.375.4,12.64.727a4.14,4.14,0,0,1,3.948,3.7A42.731,42.731,0,0,1,908,28.9a52.471,52.471,0,0,1-.522,5.334,4.039,4.039,0,0,1-3.962,3.749c-4.892.283-9.793.514-14.691.544-3.406.021-6.82-.255-10.22-.536a4.23,4.23,0,0,1-4.181-4.022,50.062,50.062,0,0,1,.005-14.741,4.238,4.238,0,0,1,4.1-4.02c4.048-.329,8.111-.468,12.359-.7m-3.238,7.025v10.15l8.8-5.079-8.8-5.071",
    transform: "translate(-16871.195 -19328.006)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16072",
    "data-name": "Path 16072",
    d: "M910.163,33.023l8.8,5.071-8.8,5.079Z",
    transform: "translate(-16893.703 -19339.488)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6869770422cf7a541b3afa1edb89a1f3.svg";
export { ForwardRef as ReactComponent };